import { render, staticRenderFns } from "./CompanyRequestRegNumberChangeModal.vue?vue&type=template&id=0d38e8fe&"
import script from "./CompanyRequestRegNumberChangeModal.vue?vue&type=script&lang=js&"
export * from "./CompanyRequestRegNumberChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports